/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Represents the various statuses that an
 * investigation demand can have during its lifecycle.
 */
export enum InvestigationDemandStatus {
    CREATED = 'created',
    HARVESTED = 'harvested',
    IN_PROGRESS = 'inProgress',
    CANCELED = 'canceled',
    COMPLETED = 'completed',
}
